import Button from "components/Buttons/Button/Button";
import Buttons from "components/Buttons/Buttons/Buttons";
import useAPI from "hooks/useAPI";
import { useEffect, useState } from "react";
import { FormInput, FormSelect, FormSelectSearch } from "../FormInputs/FormInput";
import FormWrapper from "../FormWrapper";
import LoadingWrapper from "../../Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";

export const CreateInput = ({ error, field, data, setData, setUpdateCountryId, updateCountryId, disabled }) => {
    const api = useAPI();
    const [opt, setOpt] = useState([]);
    useEffect(() => {
        if (field?.options?.fillFromApi) {
            const getOptions = async () => {
                let res = await api.get(`${field.options.fillFromApi}${field.options.fillFromApi?.includes("id_town") && updateCountryId ? `?id_country=${updateCountryId}` : ""}`);
                setOpt(res);
            };
            getOptions();
        } else if (Array.isArray(field?.options)) {
            setOpt(field?.options);
        }
    }, [updateCountryId]);

    // useEffect(() => {
    //     if (opt?.length <= 1) {
    //         setData((prev) => {
    //             return {
    //                 ...prev,
    //                 [field.field]: opt[0]?.value,
    //             };
    //         });
    //     }
    // }, []);

    switch (field.type) {
        case "select":
            return (
                <FormSelect
                    label={field.label}
                    data={data}
                    setData={setData}
                    field={field.field}
                    options={opt}
                    rows={field.rows}
                    required={field.required}
                    disabled={field.disabled}
                    columns={field.columns}
                    updateCountryId={updateCountryId}
                    setUpdateCountryId={setUpdateCountryId}
                    error={error}
                />
            );
        case "search_select":
            return (
                <FormSelectSearch
                    label={field.label}
                    data={data}
                    setData={setData}
                    field={field.field}
                    options={opt}
                    rows={field.rows}
                    required={field.required}
                    disabledco={field.disabled}
                    columns={field.columns}
                    error={error}
                />
            );
        default:
            return (
                <FormInput
                    label={field.label}
                    data={data}
                    setData={setData}
                    field={field.field}
                    placeholder={field.placeholder}
                    type={field.type}
                    rows={field.rows}
                    required={field.required}
                    disabled={field.disabled}
                    columns={field.columns}
                    error={error}
                />
            );
    }
};

/**
 * A simple form created from array of fields
 *
 * @param {Array} data Data to display in form
 * @param {function} setData Function that sets data on form input change
 * @param {Array} fields Array of fields to display in form
 * @param {{}} submit Object that contains submit label and submit action
 * @param {string} className Additional class name to be applied on FormWrapper
 * @param {string} title Title of the form
 * @param {?JSX.Element} secondaryAction Optional element (e.g. a link) shown left of the submit button
 *
 * @return {JSX.Element}
 * @constructor
 */

const CreateForm = ({ updateFormFields, fieldsError, data, setData, formFields = [], error, submit, className, title, updateCountryId, setUpdateCountryId, loading, formButtons, secondaryAction = null }) => {
    const { t } = useTranslation();

    const [fields, setFields] = useState(formFields);
    const [requiredFieldsError, setRequiredFieldsError] = useState([]);
    const [clearedFields, setClearedFields] = useState([]);

    useEffect(() => {
        setFields(formFields);
    }, [updateFormFields]);

    useEffect(() => {
        setClearedFields([]);
    }, [fieldsError]);

    const isEmptyValue = (value) => value === undefined || value === null || (typeof value === "string" && value.trim() === "");

    const validateRequiredFields = () =>
        fields.filter((field) => field.required && isEmptyValue(data?.[field.field])).map((field) => ({ name: field.field, error: t("global-validation-field_required") }));

    const handleSubmit = () => {
        const errors = validateRequiredFields();
        setRequiredFieldsError(errors);
        setClearedFields([]);

        if (errors.length === 0) {
            submit?.action && submit.action();
        }
    };

    const clearFieldError = (fieldName) => {
        setRequiredFieldsError((prev) => prev.filter((err) => err.name !== fieldName));
        setClearedFields((prev) => (prev.includes(fieldName) ? prev : [...prev, fieldName]));
    };

    const displayedErrors = (requiredFieldsError.length ? requiredFieldsError : fieldsError)?.filter((err) => !clearedFields.includes(err.name));

    return (
        <FormWrapper className={`row ${className ? className : ""}`} onSubmit={handleSubmit}>
            {title && <h5>{t(title)}:</h5>}
            {fields.map((field) => (
                <CreateInput
                    error={displayedErrors ? displayedErrors.find((err) => err.name === field.field)?.error : null}
                    key={field.label + field.type}
                    disabled={field?.field === "name" || "pib" || "maticni_broj"}
                    field={field}
                    data={data}
                    setData={(updater) => {
                        clearFieldError(field.field);
                        setData(updater);
                    }}
                    updateCountryId={updateCountryId}
                    setUpdateCountryId={setUpdateCountryId}
                />
            ))}
            {error && <p>{error}</p>}
            <div className={``}>
                {formButtons &&
                    (submit && !loading ? (
                        <Buttons align={secondaryAction ? "between" : "right"}>
                            {secondaryAction}
                            <Button type="submit" label={t(submit.label)} />
                        </Buttons>
                    ) : (
                        <Buttons align={secondaryAction ? "between" : "right"}>
                            {secondaryAction}
                            <Button type="submit" label={t(submit.label)} loading={loading} />
                        </Buttons>
                    ))}
            </div>
        </FormWrapper>
    );
};

export default CreateForm;
